<template>
	<div>
		
		<el-carousel height="900px" width="100vw">
		      <el-carousel-item style="background-color: #ffffff;" v-for="(item,index) in bannerimglist" :key="index">
		        <img  :src="item" style="opacity: 1;height: 900px;width: 100vw;"/>
		      </el-carousel-item>
		</el-carousel>
		
		<img
		 class="animate__animated  animate__fadeInRight"
		 src="https://cdn.img-sys.com/comdata/71480/202012/2020122409031674b253.jpg" style="width: 95vw;" />
		
		
		
		
		<div class=" rowsa huanhang rowsa">
			<div class="pore" style="width:33%;"
			 v-for="(item,index) in yewuList" @mouseenter="changeImage(1,index)"
				@mouseleave="changeImage(2,index)">
				<img style="width:100%;margin-bottom: 3px;" class="liuyuansu1"  :src="item.url"
					v-if="item.showIndex==2" />
				<img style="width:100%;margin-bottom: 3px;" class="liuyuansu" :src="item.focusUrl"
					v-if="item.showIndex==1" />
			</div>
		</div>
		
		<div class="colonn center_center">
			<div class="roww center_center">
				<div class="guanyuruier">关于瑞尔</div>
			</div>
			<div style="height: 45px;"></div>
			<div class="roww center_center">
				<div class="gongsitxt" style="color: brown;">公司</div>
				<div class="gongsitxt" style="color: black;font-weight: unset">历程</div>
			</div>
			<div style="height: 45px;"></div>
			<div class="roww center_center">
				<span style="line-height: 200%;width: 70%; text-indent: 2em;">
					瑞尔会展（山东）有限公司创建于2014年，至今已近7个年头，长期以来一直关注中国文化科普事业的发展，积极投身到博物馆、科技馆的建设工作中，并始终将其视作终身事业来参与。多年一路走来的学习、实践和积累过程，我们始终以饱满的激情在奋斗和探索，并期待未来能为中国科普事业贡献更多精彩的作品</span>
			</div>
			<div style="height: 45px;"></div>
			<div style="width: 70%;" class="roww rowsa animate__animated animate__slideInUp ">
				<div class="colonn center_center allline">
					<div class="fs11 number">2,014</div>
					<div>创建于2014年</div>
				</div>
				<div class="colonn center_center  allline bxians">
					<div class="fs11  number">50</div>
					<div>参与建设众多场馆</div>
				</div>
				<div class="colonn center_center  allline">
					<div class="fs11 number">100</div>
					<div>考察调研国内外场馆</div>
				</div>
			</div>
		</div>
		
		<div style="height: 140px;"></div>
	</div>
</template>


<script>
	import shouye from "../shouye/shouye.vue"
	export default {
		name: 'ComponentName', // 组件的名称
		components: {
			// swiper,
			// swiperSlide,
			shouye
		},

		data() {
			return {
				// 组件的数据属性
				swiperOption: {
					pagination: '.swiper-pagination',
					autoplay: 4500,
					loop: true,
				},
				
				yewuList: [{
					'url': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/a1.jpg',
					'focusUrl': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/11.jpg',
					showIndex: 1,
				}, {
					'url': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/2.jpg',
					'focusUrl':'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/21.jpg',
					showIndex: 1,
				}, {
					'url': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/3.jpg',
					'focusUrl': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/31.jpg',
					showIndex: 1,
				}, {
					'url': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/4.jpg',
					'focusUrl': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/41.jpg',
					showIndex: 1,
				}, {
					'url': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/5.jpg',
					'focusUrl': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/51.jpg',
					showIndex: 1,
				}, {
					'url': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/6.jpg',
					'focusUrl': 'https://shandongtibohui.zsyflive.com/profile/xd/ruier/home/61.jpg',
					showIndex: 1,
				}, ],
				bannerimglist:[
					'https://shandongtibohui.zsyflive.com/profile/xd/ruier/banner/1.jpg',
					'https://shandongtibohui.zsyflive.com/profile/xd/ruier/banner/2.jpg',
					'https://shandongtibohui.zsyflive.com/profile/xd/ruier/banner/3.jpg',
					'https://shandongtibohui.zsyflive.com/profile/xd/ruier/banner/4.jpg',
				]
			
				
			}
		},

		props: {
			// 组件的属性
		},

		 computed: {
		    // 计算属性获取屏幕宽度
		    screenWidth() {
		      return window.innerWidth;
		    },
		    // 计算属性获取屏幕高度
		    screenHeight() {
		      return window.innerHeight;
		    }
		  },

		methods: {

			changeImage(type, index) {
				console.log(type, index);
				this.yewuList[index].showIndex = type == 1 ? 2 : 1;
			},

			// 组件的方法
			onClick(i) {
				alert(i)
			}
		},

		mounted() {
			// 组件挂载后的操作
		},

		// 其他生命周期钩子函数和组件选项
	}
</script>

<style>
	@import url(shouye.css);
	
</style>